import React, { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    document.title = "ข้อกำหนดการให้บริการ - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">

            
            <h1 className="mb-2">ข้อกำหนดและเงื่อนไขการให้บริการ</h1>
            <p className="text-muted mb-4">
              เว็บไซต์ encraft.org • อัปเดตล่าสุด: 20 พฤศจิกายน 2025
            </p>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <p className="mb-4">
                  ยินดีต้อนรับสู่ encraft.org (&quot;เว็บไซต์&quot;) การเข้าใช้งาน
                  สมัครสมาชิก หรือใช้บริการต่าง ๆ บนเว็บไซต์นี้
                  ถือว่าคุณยอมรับและตกลงปฏิบัติตามข้อกำหนดและเงื่อนไขการให้บริการฉบับนี้
                  หากคุณไม่เห็นด้วยกับข้อกำหนดใด โปรดหยุดใช้งานเว็บไซต์ทันที
                </p>

                <hr />

                <section id="section-1" className="mb-4">
                  <h2 className="h5">1. คำจำกัดความ</h2>
                  <ul>
                    <li>
                      <strong>&quot;ผู้ใช้ทั่วไป&quot;</strong> หมายถึง
                      บุคคลที่เข้าชมเว็บไซต์โดยไม่ต้องสมัครสมาชิก
                    </li>
                    <li>
                      <strong>&quot;สมาชิก&quot;</strong> หมายถึง
                      บุคคลที่สมัครบัญชีผู้ใช้และเข้าสู่ระบบ
                    </li>
                    <li>
                      <strong>&quot;ผู้เขียน&quot; หรือ &quot;Creator&quot;</strong>{" "}
                      หมายถึง สมาชิกที่ได้รับสิทธิ์ในการสร้างและเผยแพร่บทความ
                    </li>
                    <li>
                      <strong>&quot;แอดมิน&quot;</strong> หมายถึง
                      ผู้ดูแลระบบและผู้มีสิทธิ์จัดการหลังบ้านของเว็บไซต์
                    </li>
                    <li>
                      <strong>&quot;AI Chat&quot;</strong> หมายถึง
                      ผู้ช่วยสนทนาอัตโนมัติที่ใช้เทคโนโลยีจากผู้ให้บริการภายนอก
                      (เช่น OpenAI) เพื่อช่วยตอบคำถามและให้ข้อมูลแก่ผู้ใช้
                    </li>
                  </ul>
                </section>

                <section id="section-2" className="mb-4">
                  <h2 className="h5">2. การสมัครสมาชิกและบัญชีผู้ใช้</h2>
                  <ul>
                    <li>
                      ผู้ใช้ต้องให้ข้อมูลที่ถูกต้อง เป็นปัจจุบัน และครบถ้วน
                      ในการสมัครสมาชิก
                    </li>
                    <li>
                      ห้ามใช้ข้อมูลเท็จ ปลอมแปลง หรือแอบอ้างเป็นบุคคลอื่น
                    </li>
                    <li>
                      สมาชิกต้องเก็บรักษาชื่อผู้ใช้และรหัสผ่านเป็นความลับ
                      และรับผิดชอบต่อการใช้งานบัญชีของตน
                    </li>
                    <li>
                      หากพบการใช้งานบัญชีโดยไม่ได้รับอนุญาต
                      ผู้ใช้ต้องรีบแจ้งผู้ดูแลระบบโดยเร็ว
                    </li>
                    <li>
                      เว็บไซต์ขอสงวนสิทธิ์ระงับหรือยกเลิกบัญชี
                      หากพบการใช้งานผิดวัตถุประสงค์ ผิดกฎหมาย
                      หรือฝ่าฝืนข้อกำหนดในเอกสารนี้
                    </li>
                  </ul>
                </section>

                <section id="section-3" className="mb-4">
                  <h2 className="h5">3. สิทธิ์และการใช้งานบริการ</h2>
                  <h3 className="h6 mt-3">3.1 ผู้ใช้ทั่วไป</h3>
                  <ul>
                    <li>สามารถเข้าชมและอ่านบทความสาธารณะบนเว็บไซต์</li>
                    <li>สามารถใช้งาน AI Chat ได้ในขอบเขตที่เว็บไซต์กำหนด</li>
                  </ul>

                  <h3 className="h6 mt-3">3.2 สมาชิก</h3>
                  <ul>
                    <li>อ่านบทความและเข้าถึงเนื้อหาบางส่วนที่สงวนไว้สำหรับสมาชิก</li>
                    <li>กดถูกใจบทความ บันทึก / bookmark บทความ</li>
                    <li>จัดการโปรไฟล์ผู้ใช้ของตนเอง</li>
                  </ul>

                  <h3 className="h6 mt-3">3.3 ผู้เขียน (Creator)</h3>
                  <ul>
                    <li>สร้าง แก้ไข และเผยแพร่บทความของตนบนเว็บไซต์</li>
                    <li>
                      ต้องรับผิดชอบต่อความถูกต้องและความเหมาะสมของเนื้อหาที่เผยแพร่
                    </li>
                    <li>
                      ห้ามคัดลอก นำผลงานของผู้อื่นมาใช้โดยไม่ได้รับอนุญาต
                      หรือฝ่าฝืนกฎหมายทรัพย์สินทางปัญญา
                    </li>
                  </ul>
                </section>

                <section id="section-4" className="mb-4">
                  <h2 className="h5">
                    4. เนื้อหาและลิขสิทธิ์ (Content &amp; Intellectual Property)
                  </h2>
                  <ul>
                    <li>
                      เนื้อหาทั้งหมดบนเว็บไซต์ รวมถึงแต่ไม่จำกัดเพียง
                      บทความ รูปภาพ โลโก้ สัญลักษณ์ ส่วนติดต่อผู้ใช้
                      และองค์ประกอบด้านการออกแบบ อยู่ภายใต้ลิขสิทธิ์ของ
                      encraft.org หรือเจ้าของเนื้อหาต้นฉบับ
                    </li>
                    <li>
                      ผู้ใช้สามารถอ่าน แบ่งปันลิงก์ หรืออ้างอิงเนื้อหาได้
                      ตามหลักการใช้งานที่เป็นธรรม แต่ห้ามคัดลอก ดัดแปลง ทำซ้ำ
                      เผยแพร่ หรือนำไปใช้ในเชิงพาณิชย์ โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษร
                    </li>
                    <li>
                      ผู้เขียนบทความยินยอมให้เว็บไซต์มีสิทธิ์ในการแสดงผล
                      จัดเก็บ ทำสำเนาในระบบ และใช้เนื้อหาดังกล่าวเพื่อประโยชน์ในการดำเนินงานของเว็บไซต์
                    </li>
                    <li>
                      เว็บไซต์ขอสงวนสิทธิ์ในการแก้ไข ซ่อน หรือลบเนื้อหาที่ผิดกฎหมาย
                      ละเมิดสิทธิผู้อื่น หรือขัดต่อหลักเกณฑ์ของเว็บไซต์
                    </li>
                  </ul>
                </section>

                <section id="section-5" className="mb-4">
                  <h2 className="h5">5. การใช้งาน AI Chat</h2>
                  <ul>
                    <li>
                      AI Chat เป็นระบบอัตโนมัติที่ใช้เพื่อช่วยตอบคำถาม
                      แนะนำเนื้อหา และอธิบายข้อมูลที่เกี่ยวข้องกับบทความและหัวข้อต่าง ๆ
                    </li>
                    <li>
                      ข้อมูลหรือคำตอบที่ได้จาก AI Chat
                      อาจไม่ถูกต้อง ครบถ้วน หรือทันสมัยอยู่เสมอ
                      ผู้ใช้ควรใช้วิจารณญาณก่อนนำไปใช้จริง
                    </li>
                    <li>
                      ในระยะเริ่มต้นของการให้บริการ
                      เว็บไซต์จะไม่จัดเก็บบันทึกข้อความสนทนา (Chat Logs)
                      ในฝั่ง encraft.org อย่างไรก็ตาม ข้อความของคุณ
                      อาจถูกประมวลผลโดยผู้ให้บริการ AI ภายนอก
                      ตามนโยบายของผู้ให้บริการนั้น
                    </li>
                    <li>ห้ามใช้ AI Chat เพื่อ:</li>
                    <ul>
                      <li>สร้างหรือเผยแพร่เนื้อหาที่ผิดกฎหมาย</li>
                      <li>ใส่ร้าย ดูหมิ่น คุกคาม หรือรบกวนผู้อื่น</li>
                      <li>
                        สร้างเนื้อหาที่ละเมิดลิขสิทธิ์
                        สิทธิส่วนบุคคล หรือทรัพย์สินทางปัญญา
                      </li>
                    </ul>
                  </ul>
                </section>

                <section id="section-6" className="mb-4">
                  <h2 className="h5">
                    6. เนื้อหาที่ผู้ใช้สร้าง (User-Generated Content)
                  </h2>
                  <ul>
                    <li>
                      ผู้ใช้เป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อเนื้อหาที่ตนสร้าง
                      ไม่ว่าจะเป็นบทความ ความคิดเห็น หรือข้อความอื่น ๆ
                    </li>
                    <li>
                      ผู้ใช้ต้องรับรองว่าเนื้อหาดังกล่าวไม่ผิดกฎหมาย
                      ไม่ละเมิดสิทธิผู้อื่น และไม่ขัดต่อศีลธรรมอันดี
                    </li>
                    <li>
                      เว็บไซต์มีสิทธิ์ตรวจสอบและลบเนื้อหาที่เห็นว่าไม่เหมาะสม
                      หรือฝ่าฝืนข้อกำหนดการใช้บริการ
                    </li>
                  </ul>
                </section>

                <section id="section-7" className="mb-4">
                  <h2 className="h5">7. ความเป็นส่วนตัวและข้อมูลส่วนบุคคล</h2>
                  <p>
                    การเก็บ ใช้ และคุ้มครองข้อมูลส่วนบุคคลของคุณ
                    เป็นไปตามนโยบายความเป็นส่วนตัว (Privacy Policy) ของเว็บไซต์
                    ซึ่งคุณสามารถศึกษาเพิ่มเติมได้ที่หน้า{" "}
                    <a href="/privacy">นโยบายความเป็นส่วนตัว</a>.
                  </p>
                </section>

                <section id="section-8" className="mb-4">
                  <h2 className="h5">
                    8. การระงับหรือยกเลิกการให้บริการและบัญชีผู้ใช้
                  </h2>
                  <ul>
                    <li>
                      เว็บไซต์ขอสงวนสิทธิ์ในการระงับการใช้งาน
                      หรือยกเลิกบัญชีของผู้ใช้
                      หากพบพฤติกรรมที่ฝ่าฝืนข้อกำหนดการให้บริการ
                      หรือมีกิจกรรมที่เสี่ยงต่อความปลอดภัยของระบบ
                    </li>
                    <li>
                      ในกรณีที่ยกเลิกบัญชี
                      ข้อมูลบางส่วนอาจยังคงถูกจัดเก็บตามที่ระบุไว้ในนโยบายความเป็นส่วนตัว
                      เพื่อวัตถุประสงค์ด้านความปลอดภัยและการปฏิบัติตามกฎหมาย
                    </li>
                  </ul>
                </section>

                <section id="section-9" className="mb-4">
                  <h2 className="h5">9. การปฏิเสธความรับผิด (Disclaimer)</h2>
                  <ul>
                    <li>
                      เว็บไซต์และบริการทั้งหมด รวมถึง AI Chat
                      ให้บริการในลักษณะ &quot;ตามสภาพที่เป็นอยู่&quot;
                      โดยไม่รับประกันความถูกต้อง ความครบถ้วน
                      หรือการทำงานต่อเนื่องปราศจากข้อผิดพลาด
                    </li>
                    <li>
                      เว็บไซต์ไม่รับผิดชอบต่อความเสียหายใด ๆ
                      ที่เกิดจากการนำข้อมูล เนื้อหา หรือคำแนะนำ
                      ไปใช้โดยตรงหรือโดยอ้อม
                    </li>
                  </ul>
                </section>

                <section id="section-10" className="mb-4">
                  <h2 className="h5">10. การแก้ไขเปลี่ยนแปลงข้อกำหนด</h2>
                  <ul>
                    <li>
                      เว็บไซต์ขอสงวนสิทธิ์ในการปรับปรุง แก้ไข
                      หรือเพิ่มเติมข้อกำหนดการให้บริการฉบับนี้ได้ทุกเมื่อ
                    </li>
                    <li>
                      เมื่อมีการเปลี่ยนแปลง
                      เราจะประกาศผ่านหน้าเว็บไซต์และระบุวันที่มีผลบังคับใช้
                    </li>
                    <li>
                      การที่คุณใช้งานเว็บไซต์หลังจากมีการปรับปรุงข้อกำหนด
                      ถือว่าคุณยอมรับข้อกำหนดฉบับที่แก้ไขแล้ว
                    </li>
                  </ul>
                </section>

                <section id="section-11" className="mb-4">
                  <h2 className="h5">11. กฎหมายที่ใช้บังคับ</h2>
                  <p>
                    ข้อกำหนดการให้บริการฉบับนี้อยู่ภายใต้บังคับของกฎหมายไทย
                    หากมีข้อพิพาทใด ๆ
                    ให้ศาลไทยเป็นผู้มีอำนาจพิจารณาและตัดสิน
                  </p>
                </section>

                <section id="section-12" className="mb-2">
                  <h2 className="h5">12. ช่องทางติดต่อ</h2>
                  <p>
                    หากคุณมีคำถาม ข้อเสนอแนะ หรือข้อร้องเรียนใด ๆ
                    เกี่ยวกับข้อกำหนดการให้บริการ
                    สามารถติดต่อเราได้ที่:
                  </p>
                  <ul>
                    <li>Email: encraft.official@gmail.com</li>
                    <li>Facebook: Encraft</li>
                    <li>Instagram: encraft_org</li>
                    <li>เว็บไซต์: https://encraft.org</li>
                  </ul>
                </section>

                <p className="text-muted small mb-0">
                  หมายเหตุ: เอกสารฉบับนี้อาจมีการปรับปรุงตามการพัฒนา
                  ฟีเจอร์ใหม่ ๆ หรือข้อกำหนดทางกฎหมายในอนาคต
                </p>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  );
}
